import { api } from 'api'
import { ErrorsNoData } from 'constants/actionMessages'
import { getCreatorAsyncSlice } from 'modules/store'

import { RootState } from '..'

const { createAsyncSlice } = getCreatorAsyncSlice<RootState>({ nameReducer: 'mlSettings' })

export const { getHosts, selectHosts, initialSliceHosts, sliceCasesHosts } = createAsyncSlice({
  nameAction: 'getHosts',
  nameSlice: 'hosts',
  promise: api.mlSettings.getHosts,
  error: ErrorsNoData.Hosts,
})

export const { getEndpoints, selectEndpoints, initialSliceEndpoints, sliceCasesEndpoints } = createAsyncSlice({
  nameAction: 'getEndpoints',
  nameSlice: 'endpoints',
  promise: api.mlSettings.getEndpoints,
  error: ErrorsNoData.Endpoints,
})

export const { getEngines, selectEngines, initialSliceEngines, sliceCasesEngines } = createAsyncSlice({
  nameAction: 'getEngines',
  nameSlice: 'engines',
  promise: api.mlSettings.getEngines,
  error: ErrorsNoData.Engines,
})
